export default __webpack_public_path__ + "static/og-064a715440fb01efc7963cba886e2512.png";